export default [
  {
    title: 'Investment Performance Platform',
    type: 'Analytics',
    techInfos: ['SQL, Python, Databricks'],
    date: '2025',
    imageUrl: '/images/projects/investment-performance.jpg',
    smallImageUrl: '/images/projects/small/investment-performance.jpg',
    url: '',
    bgColor: '#111111',
    blendMode: 'lighten',
  },
] satisfies Project[];
